import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import styles from './style.module.css';
import classNames from 'classnames';
import { ICreditCardComponent } from './typing';
import { useMemo } from 'react';

export const CreditCard = ({
  selected = false,
  labelId,
  cardData,
}: {
  selected?: boolean;
  labelId?: string;
  onClick?: () => void;
  cardData?: ICreditCardComponent;
}) => {
  const normalizedIssuer = useMemo(() => {
    return (cardData?.brand || '').replaceAll(' ', '-').toLowerCase();
  }, [cardData?.brand]);

  return (
    <div
      className={classNames(
        'scale-[90%] origin-center duration-300 w-fit',
        styles.card,
      )}
    >
      <label
        htmlFor={labelId}
        id={labelId}
        className={classNames(styles.label, {
          [styles['label-selected']]: selected,
        })}
      >
        <Cards
          number={cardData?.card_number || ''}
          issuer={normalizedIssuer}
          expiry={cardData?.expiration_date || ''}
          cvc={cardData?.cvv || ''}
          locale={{ valid: 'Validade' }}
          name={cardData?.holder_name || ''}
          focused={selected ? 'name' : ''}
          preview
        />
      </label>
    </div>
  );
};
